import {
    DashboardWidget,
    WidgetBody,
    WidgetDataPoint,
    WidgetFooter,
    WidgetHeader,
    WidgetSkeleton,
    WidgetType
} from "@flexinet/ui-components";
import {NavLink} from "react-router-dom";

interface ActiveSubscriptionsWidgetProps {
    activeCount: number;
    totalCount: number;
    totalRecurringValue: number;
    loading: boolean;
    customerId: string;
}

const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}).format(value);
};

export const ActiveSubscriptionsWidget = ({activeCount, totalCount, totalRecurringValue, loading, customerId}: ActiveSubscriptionsWidgetProps) => {

    if (loading) {
        return <WidgetSkeleton/>;
    }

    const label = totalRecurringValue > 0
        ? `${activeCount} of ${totalCount} active \u00B7 ${formatCurrency(totalRecurringValue)} recurring`
        : `${activeCount} of ${totalCount} active`;

    const dataPoints: WidgetDataPoint[] = [
        {
            value: activeCount,
            label,
            color: activeCount > 0 ? 'green' : 'gray',
        },
    ];

    const widget: WidgetType = {
        header: {
            title: 'Subscriptions',
        },
        body: {
            dataPoints,
            metrics: [],
        },
        footer: {
            actionItems: [
                {
                    label: 'View Subscriptions',
                    component: {NavLink},
                    to: `/customers/${customerId}#tab=Subscriptions`,
                    visible: true,
                },
            ],
        },
    };

    return (
        <DashboardWidget
            header={<WidgetHeader {...widget.header}/>}
            body={<WidgetBody {...widget.body}/>}
            footer={<WidgetFooter {...widget.footer}/>}
        />
    );
};
